import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { FeaturedCategoriesRequest } from '../api/featuredcategories/featuredcategoriesrequest';
import { FeaturedCategoriesResponse, FeaturedCategoriesResponseDtoImpl } from '../api/featuredcategories/featuredcategoriesresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { FeaturedCategoryBuilder } from '../dto/featuredcategory/featuredcategorybuilder';
import { FeaturedCategoryDtoImpl } from '../dto/featuredcategory/featuredcategorydto';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class FeaturedCategoriesAPIProcessorImpl extends APIProcessorImpl<FeaturedCategoriesRequest, FeaturedCategoriesResponse>
{
    private title: string;

    execute(request: FeaturedCategoriesRequest): void 
    {
        super.execute(request);

        this.title = request.getFeaturedCategoriesRequest().getTitle();
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new FeaturedCategoriesResponseDtoImpl(APIFeatures.FEATURED_CATEGORIES, "Get FeaturedCategories Success");

                let featuredCategoryDto = new FeaturedCategoryDtoImpl();
                featuredCategoryDto.setTitle(this.title);
                featuredCategoryDto.setListOfTones(new FeaturedCategoryBuilder(responseMapper.getResponseMap(),this.getContext()).buildAll());
                response.setFeaturedCategoryDtos(featuredCategoryDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new FeaturedCategoriesResponseDtoImpl(APIFeatures.FEATURED_CATEGORIES, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new FeaturedCategoriesResponseDtoImpl(APIFeatures.FEATURED_CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new FeaturedCategoriesResponseDtoImpl(APIFeatures.FEATURED_CATEGORIES, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new FeaturedCategoriesResponseDtoImpl(APIFeatures.FEATURED_CATEGORIES, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/featuredcategoriesapiprocessor.tsx